import { render, staticRenderFns } from "./AdminLopdList.vue?vue&type=template&id=67b94006&"
import script from "./AdminLopdList.vue?vue&type=script&lang=js&"
export * from "./AdminLopdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports